import { SVGProps } from "react";

const ReportsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1823_6518)">
        <path
          d="M18.7484 15.7412L17.3465 17.1656C17.3062 17.2127 17.2541 17.2484 17.1956 17.269L13.6692 18.438H15.839C16.0868 18.438 16.2876 18.6389 16.2876 18.8866C16.2876 19.1343 16.0868 19.3352 15.839 19.3352H3.89468C3.64694 19.3352 3.44608 19.1343 3.44608 18.8866C3.44608 18.6389 3.64694 18.438 3.89468 18.438H13.2246C13.1864 18.438 13.151 18.3966 13.1194 18.3651C12.9994 18.247 12.9573 18.0705 13.0112 17.911L13.2815 17.0922H3.89468C3.64694 17.0922 3.44608 16.8914 3.44608 16.6436C3.44608 16.3959 3.64694 16.195 3.89468 16.195H13.5814L14.214 14.2942C14.2297 14.2322 14.2608 14.1752 14.3047 14.1288L18.7484 9.67041V4.64362H14.7059C14.4582 4.64362 14.2624 4.46817 14.2624 4.22021V0.101562H0.972656V24.1016H18.7484V15.7412ZM3.89468 13.952H10.2316C10.4793 13.952 10.6802 14.1529 10.6802 14.4006C10.6802 14.6484 10.4793 14.8492 10.2316 14.8492H3.89468C3.64694 14.8492 3.44608 14.6484 3.44608 14.4006C3.44608 14.1529 3.64694 13.952 3.89468 13.952ZM15.839 21.5782H3.89468C3.64694 21.5782 3.44608 21.3773 3.44608 21.1296C3.44608 20.8819 3.64694 20.681 3.89468 20.681H15.839C16.0868 20.681 16.2876 20.8819 16.2876 21.1296C16.2876 21.3773 16.0868 21.5782 15.839 21.5782Z"
          fill="#43454E"
        />
        <path
          d="M15.1562 0.763672V3.74637H18.1593L15.1562 0.763672Z"
          fill="#43454E"
        />
        <path
          d="M14.1445 17.3517L16.2208 16.6575L14.8387 15.2754L14.1445 17.3517Z"
          fill="#43454E"
        />
        <path
          d="M17.0535 16.2177L22.7333 10.5254L20.9735 8.76562L15.2812 14.4454L17.0535 16.2177Z"
          fill="#43454E"
        />
        <path
          d="M24.7229 8.52862L22.9675 6.77344L21.6055 8.13237L23.3639 9.89062L24.7229 8.52862Z"
          fill="#43454E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1823_6518">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.859375 0.101562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReportsIcon;
